export default class AnswerItem {
  constructor (
    public name: string, 
    public allotment: number, 
    public body: string, 
    public correct: boolean, 
    public scopeId: number = 0
  ) {}

  public correctValue(value, isTextfield = false){
    const trimmedValue = value.trim();
    const trimmedBody = this.body.trim();

    if (isTextfield) {
      return trimmedValue && trimmedBody.split(',').some(item => item.trim() === trimmedValue);
    } else {
      return trimmedValue && trimmedBody.indexOf(trimmedValue) !== -1;
    }
  }

  public get toParams() {
    return {name: this.name, allotment: this.allotment, body: this.body, correct: this.correct, scopeId: this.scopeId}
  }

  public cloneNew(scopeId?: number): AnswerItem{
    return new AnswerItem(this.name, this.allotment, this.body, this.correct, scopeId === undefined ? this.scopeId : scopeId)
  }
}
